var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentPlain(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#275180",
    d: "M4 11.3V18a.5.5 0 0 0 .4.5h5.2v-7.3H4ZM10.4 11.3v7.3h5.2a.5.5 0 0 0 .5-.5v-6.8h-5.7ZM17.8 6.7a1 1 0 0 0-.7-.3h-3.3l.7-.4a2.1 2.1 0 1 0-3-3c-.7 1-1.2 2.2-1.4 3.4h-.2A9.9 9.9 0 0 0 8.6 3a2.1 2.1 0 0 0-3 3c.1.2.4.3.6.4H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1.1h6.7V7.4h.8v3.1H17a1 1 0 0 0 1-1v-2a1 1 0 0 0-.3-.8ZM6.3 5.3a1.1 1.1 0 1 1 1.5-1.6c.5.8.8 1.7 1 2.6-.9-.2-1.7-.5-2.5-1Zm4.9 1c.2-1 .5-1.8 1-2.6a1.1 1.1 0 1 1 1.5 1.6c-.8.5-1.6.8-2.5 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentPlain);
export default __webpack_public_path__ + "static/media/present-plain.aec31becfbdfb6af1a4f9c563fdb9daf.svg";
export { ForwardRef as ReactComponent };